import React, { createContext, useContext, useEffect, useState } from "react";
import type { EnterpriseContextType, EnterpriseStateProps } from "./types";
import { defaultValues } from "./defaultValues";
import { enterpriseService } from "../../../../services/modules/enterprise";

const initialConfig = { ...defaultValues };

const EnterpriseContext = createContext<EnterpriseContextType>(initialConfig);

export const EnterpriseProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [enterpriseState, setEnterpriseState] = useState<EnterpriseStateProps>(
    initialConfig.enterpriseState
  );

  const updateState = (newState: Partial<EnterpriseStateProps>) => {
    setEnterpriseState((prevState: EnterpriseStateProps) => ({
      ...prevState,
      ...newState,
    }));
  };

  useEffect(() => {
    if (enterpriseState.selectedEnterprise) {
      enterpriseService
        .getEnterprise(enterpriseState.selectedEnterprise)
        .then((response) => updateState({ enterpriseData: response }));
    }
  }, [enterpriseState.selectedEnterprise]);

  const value = {
    enterpriseState,
    updateState,
  };

  return (
    <EnterpriseContext.Provider value={value}>
      {children}
    </EnterpriseContext.Provider>
  );
};

const useEnterprise = () => useContext(EnterpriseContext);

export default useEnterprise;
